import { createSlice } from "@reduxjs/toolkit";

export interface UserInfoState {
	name: string;
	role: string;
	email: string;
	username: string;
	id: number | null;
	group_id: string;
	city_id: string;
	import_source: any;
	days_remaining_for_trial: number;
	is_payed: boolean;
	proctoring_disable: boolean;
	proctoring_passed: boolean;
	proctoring_passed_at: string | null;
	school_price: number | null;
}

const initialState: UserInfoState = {
	name: "",
	role: "",
	email: "",
	username: "",
	id: null,
	group_id: "",
	city_id: "",
	import_source: null,
	days_remaining_for_trial: 14,
	is_payed: false,
	proctoring_disable: false,
	proctoring_passed: false,
	proctoring_passed_at: null,
	school_price: null,
};

const userInfoReducer = createSlice({
	name: "userInfoReducer",
	initialState,
	reducers: {
		setUserName: (state, action) => {
			state.name = action.payload;
		},
		setUserUsername: (state, action) => {
			state.username = action.payload;
		},
		setUserRole: (state, action) => {
			state.role = action.payload;
		},
		setUserId: (state, action) => {
			state.id = action.payload;
		},
		setGroupId: (state, action) => {
			state.group_id = action.payload;
		},
		setCityId: (state, action) => {
			state.city_id = action.payload;
		},
		setImport: (state, action) => {
			state.import_source = action.payload;
		},
		setTrialInfo: (
			state,
			action: {
				payload: {
					days_remaining: number;
					is_payed: boolean;
					proctoring_disable?: boolean;
					proctoring_passed?: boolean;
					proctoring_passed_at?: string | null;
					school_price?: number | null;
				};
			}
		) => {
			state.days_remaining_for_trial = action.payload.days_remaining;
			state.is_payed = action.payload.is_payed;
			state.proctoring_disable = action.payload.proctoring_disable ?? false;
			state.proctoring_passed = action.payload.proctoring_passed ?? false;
			state.proctoring_passed_at = action.payload.proctoring_passed_at ?? null;
			state.school_price = action.payload.school_price ?? null;
		},
		logout: () => initialState,
	},
});

export const {
	setUserName,
	setGroupId,
	setCityId,
	setImport,
	setUserUsername,
	setUserRole,
	setUserId,
	setTrialInfo,
	logout,
} = userInfoReducer.actions;

export default userInfoReducer.reducer;
